import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { addAdminLoading : true, addAdminMessage: '', addAdminError: false};

export function AddOrganisationAdmins(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ADD_ADMIN_ORG:
        return {
            addAdminLoading: true,
            addAdminMessage: '',
            addAdminError: false
        };
      case organisationConstants.RESPONSE_ADD_ADMIN_ORG:
        return {
            addAdminLoading: false,
            addAdminMessage: action.editOrgs.data.message,
            addAdminError: false
        };
      case organisationConstants.ERROR_ADD_ADMIN_ORG:
        return { 
            addAdminLoading: false,
            addAdminMessage: action.error.response.data.message,
            addAdminError: true
        };
    case organisationConstants.DONE_ORG_ADD_ADMIN:
        return { 
            addAdminLoading: true,
            addAdminMessage: '',
            addAdminError: false
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addOrgAdmin.reducer.js